/** Dutch translations. Keys missing here fall back to English (clearly marked in UI). */

import type { EnDictionary } from './en';

export const nl: Partial<Record<keyof EnDictionary, string>> = {
  'app.name': 'Traugily',
  'app.tagline': 'Steadige vooruitgang, simpel gemaakt',
  'nav.today': 'Vandaag',
  'nav.plan': 'Plan',
  'nav.log': 'Logboek',
  'nav.progress': 'Vooruitgang',
  'nav.reports': 'Rapporten',
  'nav.calendar': 'Kalender',
  'nav.account': 'Account',
  'nav.admin': 'Beheer',

  'calendar.title': 'Kalender',
  'calendar.prev_month': 'Vorige maand',
  'calendar.next_month': 'Volgende maand',
  'calendar.blocked': 'Niet beschikbaar',
  'calendar.no_workout': 'Geen training op deze dag.',
  'calendar.begin_workout': 'Training starten',
  'calendar.delete_workout': 'Training verwijderen',
  'calendar.redo_workout': 'Training verwijderen & opnieuw doen',
  'calendar.delete_hint': 'Een voltooide training verwijderen haalt hem uit je geschiedenis, zodat je hem opnieuw kunt doen.',
  'calendar.deleted': 'Training verwijderd.',
  'calendar.reset_for_redo': 'Training opnieuw gepland — hij staat weer in je planning en is uit je geschiedenis verwijderd.',
  'calendar.status.planned': 'Gepland',
  'calendar.status.completed': 'Voltooid',
  'calendar.status.cancelled': 'Geannuleerd',
  'calendar.status.rest': 'Rustdag',
  'action.begin_workout': 'Training starten',
  'action.resume_workout': 'Training hervatten',
  'action.finish_workout': 'Training afronden',
  'action.save': 'Opslaan',
  'action.cancel': 'Annuleren',
  'action.confirm': 'Bevestigen',
  'action.retry': 'Opnieuw proberen',
  'action.back': 'Terug',
  'action.next': 'Volgende',
  'action.change_password': 'Wachtwoord wijzigen',
  'action.skip': 'Overslaan',
  'action.sign_in': 'Inloggen',
  'action.sign_up': 'Account maken',
  'action.sign_out': 'Uitloggen',
  'action.discard_workout': 'Training weggooien',
  'action.keep_draft': 'Bewaren als concept',
  'action.download': 'Downloaden',
  'action.generate_report': 'Rapport maken',
  'action.accept': 'Accepteren',
  'action.reject': 'Suggestie overslaan',
  'action.close': 'Sluiten',
  'state.loading': 'Laden…',
  'state.empty_title': 'Nog niets hier',
  'state.error_title': 'Er is iets misgegaan',
  'state.offline': 'Je bent offline. Je wijzigingen staan op dit apparaat.',
  'state.online': 'Weer online. Je wijzigingen worden gesynchroniseerd…',
  'state.saved_locally': 'Lokaal opgeslagen',
  'state.waiting_to_sync': 'Wachten op synchronisatie',
  'state.synced': 'Gesynchroniseerd',
  'state.sync_needs_attention': 'Synchronisatie heeft aandacht nodig',
  'state.conflict_title': 'Training is gewijzigd op een ander apparaat',
  'state.conflict_body':
    'Er is niets overschreven. Kies welke versie je wilt behouden — beide records blijven beschikbaar.',
  'state.conflict_keep_local': 'Wijzigingen op dit apparaat behouden',
  'state.conflict_keep_remote': 'Versie van het andere apparaat behouden',
  'state.conflict_discard_confirm': 'Ja, mijn niet-gesynchroniseerde invoer verwijderen',
  'today.title': 'Vandaag',
  'today.next_action': 'Je volgende stap',
  'today.no_session': 'Geen sessie gepland vandaag',
  'today.rest_day': 'Rustdag — herstel hoort bij het plan',
  'today.pending_proposals': '{count} plansuggesties staan voor je klaar',
  'today.unread_notifications': '{count} ongelezen meldingen',
  'today.start_onboarding': 'Stel je profiel in',
  'today.action.start_workout': 'Start je training van vandaag',
  'today.action.resume_workout': 'Hervat je training',
  'today.action.view_plan': 'Bekijk je plan',
  'today.action.start_onboarding': 'Voltooien',
  'today.action.no_workout_today': 'Vandaag geen training — rust goed uit.',
  'today.action.generate_plan': 'Plan genereren',
  'today.plan_summary': 'Weekdoel: {sessions} sessies · {minutes} min per sessie',
  'plan.title': 'Je plan',
  'plan.phase': 'Huidige fase',
  'plan.phase_remaining': '{weeks} weken te gaan',
  'plan.why': 'Waarom dit plan',
  'plan.assumptions': 'Aannames',
  'plan.rest_days': 'Rustdagen per week: {count}',
  'plan.weekly_rhythm': 'Wekelijks ritme',
  'plan.week.training': 'Training',
  'plan.week.rest': 'Rust / herstel',
  'plan.accept_prompt': 'Bekijk en accepteer je plan om te starten met trainen.',
  'plan.accept_confirm':
    'Ik begrijp dat Traugily geen medische dienst is en professionele hulp zoek bij pijn of blessures.',
  'plan.accepted': 'Plan geactiveerd',
  'plan.length_change': 'Planduur wijzigen',
  'plan.length_preview': 'Bekijk de vergelijking vóór en na vóór je bevestigt.',
  'plan.length_before': 'Vóór',
  'plan.length_after': 'Na',
  'plan.version': 'Planversie {version}',
  'log.title': 'Trainingslogboek',
  'log.history': 'Eerdere trainingen',
  'log.no_history': 'Nog geen trainingen — je eerste begint bij Vandaag.',
  'log.planned': 'Gepland',
  'log.actual': 'Uitgevoerd',
  'log.rest_timer': 'Pauzetimer',
  'log.report_pain': 'Meld ongemak of pijn',
  'log.pain.discomfort': 'Licht ongemak',
  'log.pain.pain': 'Pijn',
  'log.pain.urgent': 'Spoedgeval — duizeligheid, borstpijn, flauwvallen',
  'log.finish_summary': 'Sessiesamenvatting',
  'log.duration': 'Duur',
  'log.calories': 'Geschatte calorieverbranding',
  'log.calories_note': 'Alleen een schatting — geen medische meting.',
  'log.set_empty': 'Vul reps, gewicht, RPE of RIR in voor het opslaan — lege sets worden niet opgeslagen.',
  'log.set_saved': 'Set opgeslagen.',
  'log.set_queued_offline': 'Je bent offline — de set is op dit apparaat opgeslagen en wordt gesynchroniseerd.',
  'log.finish_failed': 'De workout kon niet worden afgerond. Probeer het opnieuw.',
  'safety.guidance.urgent':
    'Stop direct met trainen. Bij borstpijn, flauwvallen, duizeligheid, plotselinge kortademigheid of vergelijkbare klachten: zoek onmiddellijk medische hulp. Traugily kan je klachten niet beoordelen.',
  'safety.guidance.pain':
    'Bedankt dat je het meldt. Raadpleeg een bevoegde zorgverlener voordat je deze beweging hervat. We verhogen deze oefening niet totdat je een veilige volgende stap kiest.',
  'safety.guidance.discomfort':
    'Licht ongemak komt voor. Verminder belasting of bewegingsuitslag, en stop als het erger wordt of aanhoudt.',
  'safety.guidance.none': 'Bedankt voor de melding.',
  'progress.title': 'Vooruitgang',
  'progress.weigh_in': 'Wekelijkse weging',
  'progress.weigh_in_hint':
    'Voor consistente waarden: weeg na het toilet en voor het ontbijt, rond hetzelfde moment per week.',
  'progress.weight': 'Gewicht',
  'progress.trend': 'Trend (gemiddelde)',
  'progress.trend_note': 'Trends zijn beschrijvend — geen diagnose.',
  'progress.consistency': 'Consistentie',
  'progress.personal_records': 'Persoonlijke records',
  'progress.goal_review': 'Doelreview',
  'nutrition.title': 'Voeding',
  'nutrition.targets': 'Dagelijkse doelen (schattingen)',
  'nutrition.targets.estimate_notice':
    'Doelen zijn schattingen op basis van je profiel, geleidelijk aangepast per fase. Geen medisch advies.',
  'nutrition.suggestions': 'Maaltijdideeën',
  'nutrition.log_meal': 'Maaltijd noteren',
  'account.title': 'Account',
  'account.language': 'Taal',
  'account.units': 'Eenheden',
  'account.sign_out': 'Uitloggen',
  'account.export_data': 'Mijn gegevens exporteren',
  'account.delete_account': 'Account verwijderen',
  'account.plan.free': 'Gratis',
  'account.plan.premium': 'Premium',
  'account.subscribe': 'Abonneer — ongeveer €5/maand',
  'account.manage_billing': 'Beheer facturering',
  'account.change_password': 'Wachtwoord wijzigen',
  'account.change_password_heading': 'Wachtwoord wijzigen',
  'account.password_current': 'Huidwachtwoord',
  'account.password_new': 'Nieuw wachtwoord',
  'account.password_confirm': 'Bevestig nieuw wachtwoord',
  'account.password_requirements': 'Minstens 10 tekens, hoofdletter, kleine letter en cijfer.',

  'account.password_changed': 'Wachtwoord bijgewerkt.',

  'account.error.old_password_incorrect': 'Huidwachtwoord is onjuist.',
  'auth.email': 'E-mail',
  'auth.password': 'Wachtwoord',
  'auth.forgot': 'Wachtwoord vergeten?',
  'auth.reset_sent': 'Als dat e-mailadres bestaat, is een herstellink onderweg.',
  'auth.verify_notice': 'Bevestig je e-mailadres — de link staat in je inbox.',
  'auth.google': 'Doorgaan met Google',
  'auth.apple': 'Doorgaan met Apple',
  'auth.have_account': 'Al een account?',
  'auth.no_account': 'Nieuw bij Traugily?',
  'onboarding.title': 'Laten we je plan instellen',
  'onboarding.step': 'Stap {current} van {total}',
  'onboarding.save_resume': 'Je voortgang wordt bewaard — je kunt altijd doorgaan.',
  'onboarding.safety': 'Veiligheid eerst',
  'onboarding.safety_ack':
    'Ik begrijp dat Traugily geen medische dienst is en professionele hulp zoek bij pijn of blessures.',
  'admin.title': 'Beheer',
  'admin.no_access': 'Je hebt geen toegang tot dit gebied.',
  'admin.grant_premium': 'Premium toekennen',
  'admin.revoke_to_free': 'Naar gratis zetten',
  'reports.title': 'Rapporten',
  'reports.period': 'Periode',
  'reports.detail': 'Detailniveau',
  'reports.detail.summary': 'Samenvatting',
  'reports.detail.standard': 'Standaard',
  'reports.detail.detailed': 'Gedetailleerd',
  'reports.status.pending': 'In wachtrij',
  'reports.status.processing': 'Wordt gemaakt',
  'reports.status.ready': 'Klaar',
  'reports.status.failed': 'Mislukt',
  'reports.download': 'PDF downloaden',
  'reports.estimate_notice': 'Alle schattingen in het rapport zijn gelabeld.',
  'reports.start_date': 'Startdatum',
  'reports.end_date': 'Einddatum',
  'reports.language': 'Rapporttaal',
  'reports.history': 'Eerdere rapporten',
  'reports.empty': 'Nog geen rapporten',
  'reports.empty_hint': 'Kies hierboven een periode en maak je eerste PDF.',
  'reports.polling': 'Je PDF wordt gemaakt — status controleren…',
  'reports.error_dates_required': 'Kies een start- en einddatum.',
  'reports.error_date_order': 'Einddatum moet op of na startdatum liggen.',
  'error.network': 'We konden de server niet bereiken. Je lokale wijzigingen zijn veilig.',
  'error.validation': 'Controleer de gemarkeerde velden.',
  'error.permission': 'Je hebt geen toestemming voor deze actie.',
  'error.generic': 'Er is iets misgegaan. Probeer het opnieuw.',
  'offline.banner': 'Offlinemodus — wat je noteert wordt eerst op dit apparaat bewaard.',
} as const;
